import React, { FC } from 'react';
import { useIntl, getLocale } from 'umi';
import classnames from 'classnames';
import Style from './index.less';

export const openPrivatePolicy = () => {
  // const url = `/meet/policy?locale=${getLocale() === 'zh-CN' ? 'zh' : 'en'}`;
  let url = '';
  if (getLocale() === 'zh-CN') {
    // url = 'http://gb.corp.163.com/gb/legal.html';
    url = 'https://popo.gsf.netease.com/webMeetingCDN/PrivacyPolicy/zh.html';
  } else {
    // url = `${process.env.NODE_ENV === 'production' ? '/meet/' : '/'}pdf/NetEase - Candidate Privacy Notice.pdf`;
    url = 'https://popo.gsf.netease.com/webMeetingCDN/PrivacyPolicy/en.html';
  }
  window.open(url);
};

interface PrivatePolicyProps {
  agreePolicy: boolean;
  setAgreePolicy: (value: React.SetStateAction<boolean>) => void;
}

const PrivatePolicy: FC<PrivatePolicyProps> = props => {
  const { formatMessage } = useIntl();
  const { agreePolicy, setAgreePolicy } = props;

  return (
    <div className={Style.private}>
      <label className={Style.checkbox}>
        <input type="checkbox" checked={agreePolicy} readOnly />
        <span
          className={Style.checkmark}
          onClick={() => {
            setAgreePolicy(x => !x);
          }}
        />
      </label>
      {getLocale() === 'ja' ? (
        <>
          <span className={classnames(Style.link, Style.ja)} onClick={() => openPrivatePolicy()}>
            {formatMessage({ id: 'PRIVACY_POLICY' })}
          </span>
          <span className={classnames(Style.agree, Style.ja)}>{formatMessage({ id: 'I_AGREE_TO_THE' })}</span>
        </>
      ) : (
        <>
          <span className={Style.agree}>{formatMessage({ id: 'I_AGREE_TO_THE' })}</span>
          <span
            className={classnames(Style.link, { [Style.zh]: getLocale() === 'zh-CN' })}
            onClick={() => openPrivatePolicy()}
          >
            {formatMessage({ id: 'PRIVACY_POLICY' })}
          </span>
        </>
      )}
    </div>
  );
};

export default PrivatePolicy;
